import React from "react";
import { Button } from "@/components/ui/button";
import { logErrorToDatabase } from "@/hooks/useErrorLogger";

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
  error?: unknown;
};

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: unknown) {
    return { hasError: true, error };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] Caught error:", error);
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] Component stack:\n", info.componentStack);
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] Device context:", {
      viewport: `${window.innerWidth}x${window.innerHeight}`,
      userAgent: navigator.userAgent,
      route: window.location.pathname,
      pixelRatio: window.devicePixelRatio,
    });
    
    // Log to database
    logErrorToDatabase(error, "dashboard", undefined, {
      action: "render_crash",
      viewport: `${window.innerWidth}x${window.innerHeight}`,
      userAgent: navigator.userAgent,
      route: window.location.pathname,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="min-h-screen flex items-center justify-center bg-background p-6">
          <section className="max-w-lg w-full rounded-lg border bg-card p-6 text-card-foreground shadow-sm text-center">
            <h1 className="text-lg font-semibold">Ops! Algo deu errado</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              O sistema encontrou um erro e precisou interromper esta tela.
            </p>
            <div className="mt-6 flex flex-col gap-3">
              <Button size="lg" className="w-full text-base" onClick={() => window.location.reload()}>
                Atualizar página
              </Button>
              <Button variant="outline" size="sm" onClick={() => this.setState({ hasError: false, error: undefined })}>
                Tentar continuar
              </Button>
            </div>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}
